import type { Component } from "svelte";
import { CartModalKind } from "@core/schema/CartModalKind.js";
import ClearForProducts from "./ClearForProducts.svelte";
import ClearForSubscription from "./ClearForSubscription.svelte";
import FfcMembersOnly from "./FfcMembersOnly.svelte";
import OrderAlreadyExists from "./OrderAlreadyExists.svelte";
import OrderError from "./OrderError.svelte";

export const cartModalComponentMap = {
	[CartModalKind.OrderError]: OrderError,
	[CartModalKind.OrderAlreadyExists]: OrderAlreadyExists,
	[CartModalKind.ClearForSubscription]: ClearForSubscription,
	[CartModalKind.ClearForProducts]: ClearForProducts,
	[CartModalKind.FfcMembersOnly]: FfcMembersOnly,
} satisfies Record<CartModalKind, Component<never>>;
